module.exports = __webpack_public_path__ + "media/fonts/Matter-SemiBold-b148b9ad83358107bc79540106276a86.ttf";